import React, { useState, useRef, useEffect } from 'react'
import { Link } from 'react-router-dom';
import useApi from '../../utility/apiCall';
import API_URL from '../../config/config';
import { useNavigate } from 'react-router-dom';
import { useAuth, getLoggedInUserData } from '../../context/AuthContext';
import FlashMessage from '../../components/FlashMessage';


//import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
// React Bootstrap
import { Modal } from 'react-bootstrap';

// Components File
import WelcomeBox from './WelcomeBox';
import Subscription from './Subscription';
import AccountChart from '../ComomonChart/AccountChart';
import ChallengeCard from '../../components/ChallengeCard';
import CurrencyVolumeChart from '../ComomonChart/CurrencyVolumeChart';
import Loaders from '../../components/Loader';

// Icons & Images Files
import Icons from '../../components/icons';
import master from "../../img/icons/account/master.png"
import student from "../../img/icons/account/student.png"
import practitioner from "../../img/icons/account/practitioner.png"
import starpattern from "../../img/icons/pattern/star-pattern.png"
import conservativeTrader from "../../img/icons/conservative-trader.webp"

import mt5exe from '../../img/mt5.exe'
import Socialicon2 from '../../components/Socialicon2';
import AccountDropItem from '../../components/AccountDropItem';
import MeterChart from '../ComomonChart/MeterChart';
import CloseIcon from '../../components/CloseIcon';
// import LocationMap from '../../components/LocationMap';
import ProgressBar from '../ComomonChart/ProgressBar';
import DropItem from '../../components/commonfield/DropItem';


// 
function TPMSection({ className = "col-12", performancePercentage, minTradeDays, maxLossPer, maxDailyLossPr }) {
  return (
    <>
      <div className={className}>
        <div className="common-box p-0 cb-trade-performance-meter overflowhidden">
          <div className="common-box limit-card-bx">
          <div className="tpm-inner">
            <div className="common-box-heading">Trade Performance Meter</div>
            <MeterChart percentage={performancePercentage} />
          </div>
            <div className="lc-data-bx">
              <div className="ldb-item">Minimum trading days <div className='li-data'>{minTradeDays}</div> </div>
              <div className="ldb-item">Maximum loss <div className='li-data'>{maxLossPer}%</div></div>
              <div className="ldb-item">Maximum daily loss <div className='li-data'>{maxDailyLossPr}%</div></div>
          </div>
        </div>
        </div>
      </div>
    </>
  )
}

function CTSection({ className = "col-12", performancePercentage, risk }) { 
  // Initialize the progress for each risk category as 0
  let lowRiskPercentage = 0;
  let mediumRiskPercentage = 0;
  let highRiskPercentage = 0;

  // Format the performance percentage to two decimal places
  const formattedPercentage = performancePercentage.toFixed(2);

  // Set the percentage based on the risk type
  if (risk === "low") {
    lowRiskPercentage = formattedPercentage;
  } else if (risk === "medium") {
    mediumRiskPercentage = formattedPercentage;
  } else if (risk === "high") {
    highRiskPercentage = formattedPercentage;
  }

  const isZeroPercentage = formattedPercentage === "0.00";

  return (
    <div className={className}>
      <div className="common-box cb-conservative-trader overflowhidden p-0 responsive-box">
          <div className="common-box-heading-mt-2">Conservative Trader</div>
        <div className="p-2 rounded-[10px] overflow-hidden">
          <img className="ctb-img responsive-img" src={conservativeTrader} alt="Conservative Trader" />
        </div>
        <div className="ctb-inner">
          
          {/* Render ProgressBars for low, medium, and high risks */}
          <ProgressBar label="Low-risk products" percent={lowRiskPercentage && !isZeroPercentage ? formattedPercentage : 0} />
          <ProgressBar label="Medium-risk products" percent={mediumRiskPercentage && !isZeroPercentage ? formattedPercentage : 0} />
          <ProgressBar label="High-risk products" percent={highRiskPercentage && !isZeroPercentage ? formattedPercentage : 0} />
        </div>
      </div>
    </div>
  );
}




// 
function CVSection({ className = "col-12", currencyVolumnData }) {
  return (
    <>
      <div className={className}>
        <div className="common-box overflowhidden">
          <div className='d-flex align-items-center gap-2 light-theme-svg'>
            <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="40" height="40" rx="20" fill="#221E42"/>
              <g clip-path="url(#clip0_1_8545)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.9798 11.4283C14.0689 11.0513 15.5194 10.8333 17.0825 10.8333C18.6456 10.8333 20.0962 11.0513 21.1853 11.4283C21.7259 11.6154 22.2229 11.8572 22.6013 12.1669C22.9735 12.4715 23.3325 12.9314 23.3325 13.5416V15.0047C23.3325 15.1546 23.3325 15.2296 23.3027 15.285C23.2791 15.3288 23.2448 15.3632 23.201 15.3867C23.1455 15.4166 23.069 15.4166 22.9159 15.4166C21.2517 15.4166 19.6566 15.6469 18.4042 16.0804C17.7878 16.2937 17.1402 16.5952 16.6054 17.0328C16.2819 17.2976 15.8961 17.7031 15.6535 18.2503C15.6 18.3709 15.5733 18.4311 15.5274 18.4583C15.4816 18.4854 15.422 18.4804 15.303 18.4703C13.8394 18.3463 12.6047 18.0608 11.6766 17.6139C11.4916 17.5248 11.3201 17.4303 11.1623 17.3301C11.0112 17.2342 10.9356 17.1862 10.8841 17.0925C10.8325 16.9987 10.8325 16.8969 10.8325 16.6932V13.5416C10.8325 12.9314 11.1915 12.4715 11.5637 12.1669C11.9421 11.8572 12.4392 11.6154 12.9798 11.4283ZM12.6193 13.4566C12.7891 13.3177 13.0853 13.1554 13.5249 13.0032C14.3963 12.7016 15.6541 12.4999 17.0825 12.4999C18.511 12.4999 19.7687 12.7016 20.6401 13.0032C21.0797 13.1554 21.3759 13.3177 21.5457 13.4566C21.6006 13.5015 21.6006 13.5816 21.5457 13.6265C21.3759 13.7655 21.0797 13.9277 20.6401 14.0799C19.7687 14.3815 18.511 14.5833 17.0825 14.5833C15.6541 14.5833 14.3963 14.3815 13.5249 14.0799C13.0853 13.9277 12.7891 13.7655 12.6193 13.6265C12.5644 13.5816 12.5644 13.5015 12.6193 13.4566Z" fill="#35F8F8"/>
              <path d="M15.4159 20.0429C15.4159 19.8965 15.4159 19.8233 15.3722 19.7756C15.3285 19.7278 15.2547 19.7212 15.1071 19.708C13.5773 19.5711 12.2159 19.2609 11.1343 18.7401C11.0819 18.7149 11.0558 18.7023 11.0388 18.6982C10.9448 18.6751 10.8562 18.7308 10.8361 18.8255C10.8325 18.8426 10.8325 18.8699 10.8325 18.9245V21.5253C10.8325 21.746 10.8325 21.8564 10.8925 21.9558C10.9526 22.0551 11.038 22.1001 11.2089 22.1899C11.3426 22.2602 11.4867 22.3269 11.6412 22.3899C12.5256 22.7502 13.6871 22.9621 15.064 23.0596C15.2278 23.0712 15.3097 23.077 15.3628 23.0276C15.4159 22.9782 15.4159 22.8953 15.4159 22.7294V20.0429Z" fill="#35F8F8"/>
              <path d="M15.4159 24.65C15.4159 24.5007 15.4159 24.4261 15.3708 24.378C15.3258 24.3299 15.2506 24.325 15.1002 24.3152C13.5906 24.2162 12.2421 23.9844 11.1696 23.5475C11.0777 23.51 11.0318 23.4913 10.9991 23.4913C10.9293 23.4914 10.8713 23.5304 10.8449 23.595C10.8325 23.6253 10.8325 23.6727 10.8325 23.7674V25.8333C10.8325 26.4578 11.2416 26.8942 11.6013 27.1559C11.9793 27.4309 12.4726 27.6438 13.0073 27.8083C13.6652 28.0107 14.4573 28.1614 15.3277 28.2482C15.6317 28.2786 15.7837 28.2937 15.8397 28.2144C15.8958 28.1352 15.8228 27.9801 15.6769 27.6699C15.5198 27.336 15.4159 26.9463 15.4159 26.5001V24.65Z" fill="#35F8F8"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M22.916 16.6666C21.3529 16.6666 19.9024 16.8847 18.8133 17.2616C18.2727 17.4488 17.7756 17.6906 17.3972 18.0002C17.025 18.3049 16.666 18.7648 16.666 19.375V21.5673C16.666 21.9446 16.666 22.1332 16.7698 22.3212C16.8736 22.5092 17.0022 22.5902 17.2595 22.7522C18.5203 23.546 20.4646 23.9582 22.9161 23.9582C25.3676 23.9582 27.3119 23.546 28.5727 22.7522C28.8298 22.5903 28.9584 22.5093 29.0622 22.3213C29.166 22.1333 29.166 21.9446 29.166 21.5673V19.3751C29.166 18.765 28.807 18.3049 28.4348 18.0002C28.0564 17.6906 27.5593 17.4488 27.0188 17.2616C25.9297 16.8847 24.4791 16.6666 22.916 16.6666ZM19.3584 18.8366C18.9188 18.9888 18.6226 19.1511 18.4528 19.29C18.3979 19.3349 18.3979 19.415 18.4528 19.4599C18.6226 19.5989 18.9188 19.7611 19.3584 19.9133C20.2298 20.2149 21.4876 20.4166 22.916 20.4166C24.3445 20.4166 25.6022 20.2149 26.4736 19.9133C26.9132 19.7611 27.2094 19.5989 27.3792 19.4599C27.4341 19.415 27.4341 19.3349 27.3792 19.29C27.2094 19.1511 26.9132 18.9888 26.4736 18.8366C25.6022 18.535 24.3445 18.3333 22.916 18.3333C21.4876 18.3333 20.2298 18.535 19.3584 18.8366Z" fill="#35F8F8"/>
              <path d="M22.9161 25.2082C25.2894 25.2082 27.3797 24.8429 28.9091 24.0037C29.0259 23.9396 29.0842 23.9076 29.1251 23.9318C29.166 23.956 29.166 24.0213 29.166 24.152V26.5001C29.166 27.1126 28.7981 27.568 28.4277 27.8644C28.0492 28.1673 27.5528 28.4033 27.0133 28.5859C25.9261 28.9538 24.4775 29.1668 22.916 29.1668C21.3545 29.1668 19.9059 28.9538 18.8187 28.5859C18.2793 28.4033 17.7828 28.1673 17.4044 27.8644C17.0339 27.568 16.666 27.1126 16.666 26.5001V24.1519C16.666 24.0213 16.666 23.9559 16.7069 23.9317C16.7478 23.9075 16.8062 23.9396 16.9229 24.0036C18.4523 24.8429 20.5428 25.2082 22.9161 25.2082Z" fill="#35F8F8"/>
              </g>
              <defs>
              <clipPath id="clip0_1_8545">
              <rect width="20" height="20" fill="white" transform="translate(10 10)"/>
              </clipPath>
              </defs>
            </svg>
            <div className="common-box-heading mb-0">
              Currency Volume
            </div>
          </div>
          <CurrencyVolumeChart currencyVolumnData={currencyVolumnData} />
        </div>
      </div>
    </>
  )
}

// 
function SocialSection({ className = "col-12" }) {
  return (
    <>
      <div className={className}>
        <div className="common-box">
          <Socialicon2 />
        </div>
      </div>
    </>
  )
}

export default function PageDashboard() {
  const { apiCall } = useApi();
  const navigate = useNavigate();
  const { state, dispatch } = useAuth();
  const token = state.token || '';
  const isInitialMount = useRef(true);
  const [isLoading, setIsLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  // ---
  const [isCredentialsModal, setIsCredentialsModal] = useState(false);
  const [challengeRequests, setChallengeRequests] = useState(false);
  const [realAccountRequests, setRealAccountRequests] = useState(false);
  const [challengeRecords, setChallengeRecords] = useState(false);
  const [challenges, setChallenges] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [email, setEmail] = useState('');
  const [masterPassword, setMasterPassword] = useState('');
  const [accountNumber, setAccountNumber] = useState('');


  const [stepValue, setStepValue] = useState('');
  const [accountStatusValue, setAccountStatusValue] = useState('');
  const [typeValue, setTypeValue] = useState('');

  const [requestSubmitError, setRequestSubmitError] = useState(false);
  const [requestSubmitErrorMsg, setRequestSubmitErrorMsg] = useState(false);
  const [requestSubmitSuccess, setRequestSubmitSuccsess] = useState(false);
  const [requestSubmitSuccessMsg, setRequestSubmitSuccessMsg] = useState(false);

  const [accountDetailNumber, setAccountDetailNumber] = useState('');
  const [accountBalance, setAccountBalance] = useState('');
  const [accountEquity, setAccountEquity] = useState('');
  const [avgWin, setAvgWin] = useState(0);
  const [avgLoss, setAvgLoss] = useState(0);
  const [totalLoss, setTotalLoss] = useState(0);
  const [totalProfit, setTotalProfit] = useState(0);
  const [accountSize, setAccountSize] = useState(0);
  const [winRatio, setWinRatio] = useState(0);
  const [accountType, setAccountTypeList] = useState([]);
  const [name, setName] = useState('');
  const [currentAccount, setCurrentAccount] = useState([]);
  const [photoUrl, setPhotoUrl] = useState(null);
  const [tradePerformanceData, setTradePerformanceData] = useState(null);
  const [performancePercentage, setPerformancePercentage] = useState(0);
  const [risk, setRisk] = useState(0);
  const [filterApply, setFilterApply] = useState(0);
  const [chartType, setChartType] = useState('line');
  const [minTradeDays, setMinTradeDays] = useState(0);
  const [maxLossPer, setMaxLossPer] = useState(0);
  const [maxDailyLossPr, setMaxDailyLossPer] = useState(0);

  const handleCredentialsModalClose = () => {
    setIsCredentialsModal(false);
  };


  const handleCardClick = (index) => {
    setActiveIndex(index);
  };

  const copyClick = (value) => {
    setRequestSubmitSuccsess(false);
    setRequestSubmitError(false);

    navigator.clipboard.writeText(value)
      .then(() => {
        setRequestSubmitSuccsess(true);
        setRequestSubmitSuccessMsg('Text copied to clipboard');
        // console.log('Text copied to clipboard');
      })
      .catch((error) => {
        setRequestSubmitError(true)
        setRequestSubmitErrorMsg('Error copying text')
        // console.error('Error copying text: ', error);
      });
  };

  const fetchTradePerformanceData = async (accountNumber) => {
    const loggedInUser = getLoggedInUserData();
    if (loggedInUser && loggedInUser.id && token) {
      try {
        setIsLoading(true);
        const response = await apiCall(API_URL + 'get-trade-performance-meter', {
          account_number: accountNumber,
          token: token,
        });
  
        // Log the entire response to understand its structure
        console.log('API Response:', response);
  
        if (response.data.success == 0) {
          const { performancePercentage } = response.data.data;
          console.log('fdgfg', response.data.data.performancePercentage)
          setTradePerformanceData(response.data.data);
          setPerformancePercentage(response.data.data.performancePercentage);
          setRisk(response.data.data.riskType); 
        } else {
          console.error('Failed to fetch trade performance data:', response.data.message || 'No message');
        }
      } catch (error) {
        console.error('Error fetching trade performance data:', error);
      } finally {
        setIsLoading(false);
      }
    } else {
      console.error('User not logged in or invalid token');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const loggedInUser = getLoggedInUserData();
      const isUserLoggedIn = !!loggedInUser;

      if (isUserLoggedIn) {
        if (loggedInUser.id && token) {
          try {
            const userDetail = await getUserProfile();
            //const requests = await getChallengeRequests();
            //const accountRequests = await getRealAccountRequests();
            const records = await getChallengeRecords();
            setDataLoaded(true)
            // console.log(records);
            // Assuming getUserWalletGroupWise returns the data needed for wallets and walletGroups
          } catch (error) {
            console.error('Failed to fetch wallet group data:', error);
          }
        }
      }
    };

    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchData();
    }
  }, [token]);

  useEffect(() => {
    if (activeIndex == 0 && challengeRecords && challengeRecords.length > 0) {
      const option = challengeRecords[activeIndex];
      getProfitDataChart(option.id, selectedOption);
      getUserWalletDetails(option.id);
      getCurrencyVolumn(option.id);
      fetchTradePerformanceData(option.account_number);
      setMinTradeDays(option.account_size.min_trade_days);
      setMaxLossPer(option.account_size.max_overall_loss);
      setMaxDailyLossPer(option.account_size.max_daily_loss);
    }
  }, [challengeRecords]);

  useEffect(() => {
    if (stepValue != '' || accountStatusValue != '' || typeValue != '') {
      getChallengeRequests();
      getRealAccountRequests();
      getChallengeRecords();
    }
  }, [stepValue, accountStatusValue, typeValue])

  const removeSpaceWIthLowerCaseString = (inputString) => {
    return inputString.replace(/\s/g, '').toLowerCase();
  };
  const getUserProfile = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-profile', {
        user_id: state.userData.id,
        token: token,
        nopaginate: 1,
      });
      if (response.data.success == '0') {
        // console.log(response.data.data);
        setName(response.data.data.first_name + ' ' + response.data.data.last_name);
        if (response.data.data.thumb_url) {
          setPhotoUrl(response.data.data.thumb_url);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const getChallengeRequests = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-challenge-requests', {
        user_id: state.userData.id,
        token: token,
        step: stepValue,
        account_status: accountStatusValue,
        type: typeValue,
        nopaginate: 1
      });
      if (response.data.success == '0') {
        // console.log(response.data.data);
        if (response.data.data.length > 0) {
          setChallengeRequests(response.data.data);
        } else {
          setChallengeRequests(null);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getRealAccountRequests = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-real-account-requests', {
        user_id: state.userData.id,
        token: token,
        nopaginate: 1
      });
      if (response.data.success == '0') {
        // console.log(response.data.data);
        if (response.data.data.length > 0) {
          console.log('realaccountrequest' + response.data.data);
          setRealAccountRequests(response.data.data);
        } else {
          setRealAccountRequests(null);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };


  const handleAccountChange = (event) => {
    // console.log(event.target.value);
    const newValue = event.target.value;
    setFilterApply(1);
    if (newValue == 'all') {
      setStepValue('all');
    } else {
      setStepValue(newValue);
    }
  }
  const handleStatusChange = (event) => {
    setFilterApply(1);
    const newValue = event.target.value;
    if (newValue == 'all') {
      setAccountStatusValue('all');
    } else {
      setAccountStatusValue(newValue);
    }

  }
  const handleTypeChange = (event) => {
    setFilterApply(1);
    const newValue = event.target.value;

    if (newValue == 'all') {
      setTypeValue('all');
    } else {
      setTypeValue(newValue);
    }
  }

  const handleCredentialsModalShow = async (challengeID) => {
    try {
      const response = await apiCall(API_URL + 'get-challenge-details', {
        user_id: state.userData.id,
        id: challengeID,
        token: token
      });
      if (response.data.success == '0') {
        // console.log(response.data);
        setEmail(response.data.data.email);
        setAccountNumber(response.data.data.account_number);
        setMasterPassword(response.data.data.master_password);
        setIsCredentialsModal(true);
        // setChallengeDetails(response.data);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    // alert(challengeID);
    // Logic to get user wallet group-wise data

  };

  const formatStatus = (status) => {
    if (!status) return ''; // Handle case where status might be undefined or null
    if (status == 'passed') {
      status = 'Profit target achieved';
    }
    const formattedStatus = status.replace(/_/g, ' '); // Replace underscores with spaces
    return formattedStatus.charAt(0).toUpperCase() + formattedStatus.slice(1); // Capitalize first letter
  };

  const getChallengeRecords = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-challenges', {
        user_id: state.userData.id,
        status: 'active',
        token: token,
        step: stepValue,
        account_status: accountStatusValue,
        type: typeValue,
        nopaginate: 1
      });
      if (response.data.success == '0') {
        if (response.data.data.length > 0) {
          //console.log(response.data.data);
          setChallengeRecords(response.data.data);
        } else {
          setChallengeRecords(null);
        }

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getAccountTypeList = async () => {
    // Logic to get user wallet group-wise data
    try {
      const response = await apiCall(API_URL + 'get-account-type-list', {
        user_id: state.userData.id,
        status: 'active',
        token: token,
        step: stepValue,
        account_status: accountStatusValue,
        type: typeValue,
        nopaginate: 1
      });
      if (response.data.success == '0') {
        if (response.data.data.length > 0) {
          console.log('accountType', response.data.data);
          setAccountTypeList(response.data.data);
        } else {
          setAccountTypeList([]);
        }

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  // ---

  const accountListGet = () => {
    const manualEntry = { value: 'all', name: 'All accounts' };
    const mappedData = accountType.map(item => ({
      value: item.step,
      name: item.step
    }))
    return [manualEntry, ...mappedData];

  };

  const Allaccounts = accountListGet();

  const Accountstatus = [
    { value: 'all', name: 'All' },
    // { value: 'New', name: 'New' },
    // { value: 'Ongoining', name: 'Ongoining' },
    { value: 'not_passed', name: 'Not Passed' },
    { value: 'passed', name: 'Passed' },
    // { value: 'CHF', name: 'CHF' },
  ];

  const Accounttype = [
    { value: 'all', name: 'All account' },
    { value: 'Student', name: 'Student' },
    { value: 'Practitioner', name: 'Practitioner' },
    { value: 'Master', name: 'Master' },
  ];

  const handleChange = () => {
  };

  // const getProfitDataChart = async () => {
  //   try {
  //     setIsLoading(true);
  //     // console.log({id});
  //     const response = await apiCall(API_URL +'get-trade-data-for-chart', {
  //         user_id: state.userData.id,
  //         token: token,
  //         user_wallet_id:id
  //     });
  //     if (response.data.success == '0') {
  //       console.log('trading list history', response.data.data.profitData);
  //         setProfitChartData(response.data.data.profitData);
  //         // setProfitChartData(response.data.data.data)
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //       console.error('Error fetching data:', error);
  //   }
  // };


  const [profitChartData, setProfitChartData] = useState([]);
  const [currencyVolumnData, setCurrencyVolumnData] = useState([]);
  useEffect(() => {
    // Function to fetch profit data for a specific user_wallet_id
    // Fetch profit data when activeIndex changes
    if (activeIndex !== null && challengeRecords && challengeRecords.length > 0) {
      const option = challengeRecords[activeIndex];
      setCurrentAccount(option);
      // getProfitDataChart(option.id);
      getProfitDataChart(option.id,selectedOption);
      getUserWalletDetails(option.id);
      getCurrencyVolumn(option.id);
      fetchTradePerformanceData(option.account_number);
    }
  }, [activeIndex]); // Depend on activeIndex changes

  const getProfitDataChart = async (userWalletId, filterOption) => {
    try {
      setIsLoading(true);
      const response = await apiCall(API_URL + 'get-trade-data-for-chart', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: userWalletId,
        filter_apply_value: filterOption,
      });
      //console.log('responseresponse',response.data);
      if (response.data.success == '0') {
        // console.log(response.data.data.profitData);
        setProfitChartData(response.data.data.profitData);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  const getCurrencyVolumn = async (userWalletId) => {
    try {
      setIsLoading(true);
      const response = await apiCall(API_URL + 'get-currency-volumn', {
        user_id: state.userData.id,
        token: token,
        user_wallet_id: userWalletId,
      });
      //console.log('responseresponse',response.data);
      if (response.data.success == '0') {
        // console.log(response.data.data.profitData);
        setCurrencyVolumnData(response.data.data.trades);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };


  const getUserWalletDetails = async (userWalletId) => {
    try {
      setIsLoading(true);
      // console.log({id});
      const response = await apiCall(API_URL + 'get-trade-dashboard-details', {
        user_id: state.userData.id,
        token: token,
        userWalletID: userWalletId
      });
      //console.log('responseresponse',response.data);
      if (response.data.success == '0') {
        // console.log(response.data.data.profitData);
        const dashboardDetails = response.data.data;
        setAccountDetailNumber(dashboardDetails.challengeInfo.account_number);
        setAccountBalance(dashboardDetails.challengeInfo.available_balance);
        setAccountEquity(dashboardDetails.challengeInfo.equity);
        setAvgWin(dashboardDetails.winAverage);
        setAvgLoss(dashboardDetails.lossAverage);
        setTotalLoss(dashboardDetails.totalLoss);
        setTotalProfit(dashboardDetails.totalProfit);
        setWinRatio(dashboardDetails.winRatio);
        setAccountSize(dashboardDetails.challengeInfo.account_size.limit);
        // setAccountNumber(dashboardDetails.challengeInfo.account_number);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading(false);
    }
  };

  // Demo
  const [selectedOption, setSelectedOption] = useState('daily');
  const options = ['daily', 'week', 'month'];

  const handleOptionChange = (option) => {
    setSelectedOption(option);
    console.log('Selected Option:', option);

    // Call getProfitDataChart with the new option
    getProfitDataChart(challengeRecords[activeIndex].id, option);
  };


  const handleAccontChange = (account) => {
    setActiveIndex(account)
  }

  // Sections hide & show
  const [isDesktop, setIsDesktop] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleLogic = () => {
      const width = window.innerWidth;

      if (width >= 992) {
        setIsDesktop(true);
        setIsTablet(false);
        setIsMobile(false);
      } else if (width >= 768) {
        setIsDesktop(false);
        setIsTablet(true);
        setIsMobile(false);
      } else if (width < 768) {
        setIsDesktop(false);
        setIsTablet(false);
        setIsMobile(true);
      }
    };

    // Initial check
    handleLogic();

    // Add event listener
    window.addEventListener("resize", handleLogic);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleLogic);
    };
  }, []);

  return (
    <>
      {!dataLoaded && <Loaders />}

      <div className="container-lg cl-custome3">
        {/* Dashboard Section 02 Start */}
        {(((challengeRecords !== null) || filterApply == 1)) &&
          <>
            <div className="aib-outer">
              <div className='d-flex gap-3 align-items-center'>
                  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect y="0.5" width="40" height="40" rx="20" fill="url(#paint0_linear_1_7996)"/>
                      <path d="M21.6674 28H18.3341M11.9123 15.3499C11.9003 14.1404 12.5524 13.011 13.6058 12.4166M28.0859 15.3499C28.0979 14.1404 27.4458 13.011 26.3924 12.4166M25.0007 17.1666C25.0007 15.8405 24.474 14.5688 23.5363 13.6311C22.5986 12.6934 21.3268 12.1666 20.0007 12.1666C18.6747 12.1666 17.4029 12.6934 16.4652 13.6311C15.5275 14.5688 15.0007 15.8405 15.0007 17.1666C15.0007 19.7418 14.3511 21.5049 13.6255 22.6711C13.0133 23.6549 12.7073 24.1467 12.7185 24.2839C12.7309 24.4359 12.7631 24.4938 12.8856 24.5846C12.9961 24.6666 13.4946 24.6666 14.4914 24.6666H25.51C26.5069 24.6666 27.0054 24.6666 27.1159 24.5846C27.2384 24.4938 27.2705 24.4359 27.283 24.2839C27.2942 24.1467 26.9881 23.6549 26.376 22.6711C25.6503 21.5049 25.0007 19.7418 25.0007 17.1666Z" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                      <defs>
                        <linearGradient id="paint0_linear_1_7996" x1="40.5" y1="40.5" x2="-7.71226" y2="27.2616" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#A4B3FF"/>
                          <stop offset="1" stop-color="#5A52FF"/>
                        </linearGradient>
                      </defs>
                  </svg>
                <div className="account-info-balance">
                  <div className="aib-name">Hello, {name}</div>
                  <div className="aib-balance">{accountBalance ? '$' + accountBalance : ''}</div>
                </div>
              </div>
              <div>
                <div className="cdi-account-label text-end">Account</div>
                <AccountDropItem onChange={handleAccontChange} selected={activeIndex} options={challengeRecords} />
              </div>
            </div>

            <div className="current-challenge-info">
              <div className="cci-right">
                <div className="row row-gap-3">

                  {challengeRecords && challengeRecords.map((option, index) => (
                    // const accountType = option.account_type || 'defaultType'
                    // const step = option.account_type || 'defaultStep'
                    activeIndex == index && <ChallengeCard
                      to={"/account-detail/" + option.id}
                      col="col-lg-4 order-1"
                      className={index == activeIndex ? 'active' : ''}
                      //imgSrc={(option.account_type != undefined && option.account_type.name == 'Student') ? student : (option.account_type != undefined && option.account_type.name == 'Practitioner' ? practitioner : master)}
                      imgSrc={photoUrl || student}
                      step={option.account_type != undefined ? option.account_type.step : ''}
                      name={"MT5 " + option.account_number}
                      //type={option.account_type != undefined ? option.account_type.name : ''}
                      type={((option.account_status == 'real') ? 'Practitioner' : 'Student')}
                      status={formatStatus(option.account_status)}
                      statusClass={(option.account_status == 'not_passed') ? 'status-red2' : (option.account_status == 'refunded' ? 'status-yellow2' : (option.account_status == 'passed' ? 'status-green2' : (option.account_status == 'disabled' ? 'status-yellow2' : 'status-yellow2')))}
                      trades={option.no_of_trades}
                      days={option.days_traded}
                      CredentialsClick={() => handleCredentialsModalShow(option.id)}
                      BoxClick={() => handleCardClick(index)} // Pass index to handleCardClick
                    />
                  ))}

                  <TPMSection className="col-lg-4 col-sm-6 order-sm-2 order-2" performancePercentage={performancePercentage} minTradeDays={minTradeDays} maxLossPer={maxLossPer} maxDailyLossPr={maxDailyLossPr}/>
                  <CTSection className="col-lg-4 col-sm-6 order-sm-2 order-2" performancePercentage={performancePercentage} risk={risk} />

                  {(((challengeRequests !== null || challengeRecords !== null))) &&
                    <div className="col-12 order-sm-3 order-4">
                      <div className='common-box'>
                      <div className="dwmy-filter-bx">
                        <div className="common-box-heading mb-0 cbh-flex">
                        <div className="cbh-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M10.2795 1.10767C10.1035 1.01969 9.89644 1.01969 9.72048 1.10767L1.38715 5.27434C1.17541 5.38021 1.04166 5.59662 1.04166 5.83335V8.12502H18.9583V5.83335C18.9583 5.59662 18.8246 5.38021 18.6128 5.27434L10.2795 1.10767ZM10.8335 5.00006H9.16682V6.66673H10.8335V5.00006Z" fill="#35F8F8" />
                          <path d="M1.04224 16.2501C1.04224 15.9049 1.32206 15.6251 1.66724 15.6251H18.3339C18.4997 15.6251 18.6587 15.6909 18.7759 15.8081C18.8931 15.9254 18.9589 16.0843 18.9589 16.2501L18.9586 18.3335C18.9586 18.6786 18.6788 18.9584 18.3336 18.9584H1.66724C1.32206 18.9584 1.04224 18.6786 1.04224 18.3334V16.2501Z" fill="#35F8F8" />
                          <path d="M17.2918 9.37506H12.7085V14.3751H17.2918V9.37506Z" fill="#35F8F8" />
                          <path d="M7.29183 9.37506H2.7085V14.3751H7.29183V9.37506Z" fill="#35F8F8" />
                        </svg>
                      </div>
                      Account Overview</div>
                        <div className="signinup-group sg-aof-bx sab-dwmy-filter mb-0">
                          {/* <div className="sg-list-bx">
                            <div className="sg-list-item active">Daily</div>
                            <div className="sg-list-item">Weekly</div>
                            <div className="sg-list-item">Monthly</div>
                            <div className="sg-list-item">Yearly</div>
                            
                          </div> */}
                          {/* <div className="sg-list-bx">
                            {options.map((option) => (
                              <div
                                key={option}
                                className={`sg-list-item ${selectedOption === option ? 'active' : ''}`}
                                onClick={() => handleOptionChange(option)}
                              >
                                {option.charAt(0).toUpperCase() + option.slice(1)} 
                              </div>
                            ))}
                          </div> */}
                           <DropItem 
                              className='ci-tf-capitalize'
                              options={options}
                              selectedOption={selectedOption}
                              onChange={handleOptionChange}
                            />
                        </div>
                      </div>

                      <div className="common-box common-box-light overflowhidden">

                        <div className="signinup-group sg-aof-bx sab-lb-filter">
                          <div className="sg-list-bx border-0">
                            <div className={`sg-list-item ${chartType === 'line' ? 'active' : ''}`} onClick={() => setChartType('line')}>Line Chart</div>
                            <div className={`sg-list-item ${chartType === 'bar' ? 'active' : ''}`} onClick={() => setChartType('bar')}>Bar Chart</div>
                          </div>
                        </div>

                        <div className="aoi-outer">
                          <div className="account-overview-item">
                            <div className="aoi-label">Account balance</div>
                            <div className="aoi-data">${accountBalance > 0 ? parseFloat(accountBalance).toFixed(2) : 0}</div>
                          </div>

                          <div className="account-overview-item">
                            <div className="aoi-label">Equity</div>
                            <div className="aoi-data">${accountEquity > 0 ? parseFloat(accountEquity).toFixed(2) : 0}</div>
                          </div>

                          <div className="account-overview-item">
                            <div className="aoi-label">Profit</div>
                            <div className="aoi-data status-neon-green">{totalProfit != 0 && accountBalance > 0 ? parseFloat((totalProfit / accountSize) * 100).toFixed(2) : 0}%</div>
                          </div>
                        </div>

                        <AccountChart profitChartData={profitChartData} chartType={chartType} filterValue={selectedOption} />


                      </div>
                        <div className="aoi-outer aoi-style-2 mt-4">
                          <div className="aoi-inner">
                            <div className="account-overview-item">
                              <div className="aoi-label">Average win</div>
                              <div className="aoi-data">${avgWin > 0 ? parseFloat(avgWin).toFixed(2) : 0}<span className='aoi-status-green'>+10.9%</span></div>
                            </div>
                          </div>

                          <div className="aoi-inner">
                            <div className="account-overview-item">
                              <div className="aoi-label">Average loss</div>
                              <div className="aoi-data">${avgLoss > 0 ? parseFloat(avgLoss).toFixed(2) : 0}<span className='aoi-status-red'>-3.9%</span></div>
                            </div>
                          </div>

                          <div className="aoi-inner">
                            <div className="account-overview-item">
                              <div className="aoi-label">Win ratio</div>
                              <div className="aoi-data">{winRatio > 0 ? winRatio.toFixed(2) : 0}%</div>
                            </div>
                          </div>

                          <div className="aoi-inner">
                            <div className="account-overview-item">
                              <div className="aoi-label">Profit Factor</div>
                              <div className="aoi-data">{totalProfit > 0 && totalLoss != 0 ? (totalProfit / totalLoss).toFixed(2) : 0}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                  }
                  
                  

                </div>
              {/* <div className="cci-left"> */}
                {/* <div className="row row-gap-3"> */}
                  {/* <LocationMap className="col-lg-12 col-sm-6 order-lg-4 order-3" /> */}
                  {/* {(isTablet || isMobile) && <Subscription className="col-lg-12 order-lg-5 order-4" />} */}
                {/* </div> */}
              {/* </div> */}

                  <div className='row row-gap-3 mt-3'>
                    <CVSection className="col-lg-6" currencyVolumnData={currencyVolumnData} />
                    <div className='col-lg-6 order-lg-3 order-6 social-sub-section'>
                        <div className="row row-gap-3">
                            <SocialSection className="col-lg-12 order-lg-4 order-7" />
                            <Subscription className="order-4"/>
                        </div>
                    </div>
                  </div>
              </div>
            </div>

          </>
        }
        {/* Dashboard Section 02 End */}

        {/* Dashboard Section 01 Start */}
        {(challengeRecords === null && filterApply == 0) &&
          <>
            <div className="pattern-bx">
              {/* <img className="star-pattern" src={starpattern} alt="" /> */}
            </div>
            <WelcomeBox />
          </>
        }
        {/* Dashboard Section 01 End */}
      </div>

      {/* --- Credentials Modal --- */}
      <Modal className="zoom custom-content" centered show={isCredentialsModal} onHide={handleCredentialsModalClose}>
        <div className="custom-modal-header">
          <div className="cmh-lable">Account Credentials</div>
          <div className="cmh-sub-lable">{'#' + accountNumber}</div>

          <CloseIcon onClick={handleCredentialsModalClose} />
        </div>

        <div className="custom-modal-body">
          <div className="challenge-credentials-bx">

            <div className={"credential-item " + email != '' ? 'd-none' : ''}>
              <div className="credential-label">Email</div>
              <div className="credential-data">{email}<span className="credential-icon" onClick={() => copyClick(email)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Username</div>
              <div className="credential-data">{accountNumber}<span className="credential-icon" onClick={() => copyClick(accountNumber)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Password</div>
              <div className="credential-data">{masterPassword}<span className="credential-icon" onClick={() => copyClick(masterPassword)}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Server</div>
              <div className="credential-data">Winprofx-Live<span className="credential-icon" onClick={() => copyClick("Winprofx-Live")}><Icons.CopySvg /></span></div>
            </div>
            <div className="credential-item">
              <div className="credential-label">Platform</div>
              <div className="credential-data">Metatrader 5<span className="credential-icon" onClick={() => copyClick("Metatrader 5")}><Icons.CopySvg /></span></div>
            </div>
          </div>
          <div className="mt-3 mb-4">
            <a download={true} href={mt5exe} className="common-btn cb-white-fill mx-auto" style={{zIndex:"0"}}><span>Open META TRADER 5</span></a>
          </div>
        </div>
      </Modal>

      <FlashMessage type="success" isVisible={requestSubmitSuccess} message={requestSubmitSuccessMsg} />
      <FlashMessage type="error" isVisible={requestSubmitError} message={requestSubmitErrorMsg} />
    </>
  )
}
